import { render, staticRenderFns } from "./table.vue?vue&type=template&id=2127d740&"
import script from "./table.js?vue&type=script&lang=js&"
export * from "./table.js?vue&type=script&lang=js&"
import style0 from "./table.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports